/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPremiumicon32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={44}
      height={49}
      fill='none'
      viewBox='0 0 44 49'
      {...props}
    >
      <g filter='url(#premium_icon-32_svg__filter0_d)'>
        <path
          fill='currentColor'
          d='M33.04 7.183l-10.8-2.16a1.2 1.2 0 00-.47 0l-10.8 2.16A1.2 1.2 0 0010 8.36v12.216c0 9.6 12 13.2 12 13.2s12-3.6 12-13.2V8.36a1.2 1.2 0 00-.96-1.177zM20.868 24.742l-5.365-5.366L17.2 17.68l3.532 3.531 7.138-8.326 1.822 1.56-8.824 10.297z'
        />
      </g>
      <defs>
        <filter
          id='premium_icon-32_svg__filter0_d'
          width={44}
          height={48.776}
          x={0}
          y={0}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values='0 0 0 0 0.0352941 0 0 0 0 0.0392157 0 0 0 0 0.0431373 0 0 0 0.05 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgPremiumicon32;
